import { GENERATED_LEAD_REPORT_LIST } from "@/libs/userAbility/userAbilityRoles/generatedLeadReport";

const GeneratedLeadReportList = () =>
  import(/* webpackChunkName 'GeneratedLeadReportList' */ "@/components/GeneratedLeadReport/GeneratedLeadReportList/GeneratedLeadReportList.vue");

export default {
  path: "generated-lead-report",
  name: "generated-lead-report-list",
  meta: {
    label: "Lead Reports",
    accessLevel: [GENERATED_LEAD_REPORT_LIST],
  },
  props: true,
  component: GeneratedLeadReportList,
};
